// части вхождений имен ботов поисковиков
export const BOT_NAMES = [
    'bot',
    'mail.ru',
    'google',
    'yandex',
    // SEO tools
    'dotbot',
    'semrushbot',
    'pingdom',
    'ahrefsbot',
];

export const getIsBot = (userAgent?: string | null): boolean => {
    const userAgentString = String(userAgent || '').toLowerCase();
    return BOT_NAMES.some(botName => userAgentString.includes(botName));
};
